import axios from 'axios'
import { BALANCES_API, WITH_CREDENTIALS_CONFIG } from './constants'

export const getBalances = (accountNumber: string, processDate?: string) => {
  const processDateQueryString = processDate
    ? `?processDate=${processDate}`
    : ''
  return axios.get(
    `${BALANCES_API}/${accountNumber}${processDateQueryString}`,
    WITH_CREDENTIALS_CONFIG
  )
}
